export default "__VITE_ASSET__Cugufulm__"